import styled from 'styled-components';

export const FooterWrapper = styled.footer`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 80px 30px;

  background-size: cover;
  background-repeat: no-repeat;
`;

export const FooterRow = styled.div`
  display: flex;
  margin: 10px 0;
  max-width: 60%;

  &.footer-row--small {
    display: flex;
    flex-direction: row;
    align-items: center;

    .footer__link {
      font-size: 12px;
    }
    
  }
  &.footer-row--top-gap {
    margin-top: 50px;
  }

  @media (max-width: 1028px) {
    max-width: 100%;
    flex-wrap: wrap;
    justify-content: center;

    &.footer-row--top-gap {
      margin-top: 30px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/footer/styles/footer.style.js